export const signupPubIds = {
  pubId_Local_General_SignUpSuccess: "pubId_Local_General_SignUpSuccess",
};

export const taskPubIds = {
  // WebSocket notification
  pubId_Task_NewMessage: "pubId_Task_NewMessage",
  pubId_Task_MarkRead: "pubId_Task_MarkRead",

  // Local notification
  pubId_Local_Task_UpdateTaskStatus: "pubId_Local_Task_UpdateTaskStatus",
  pubId_Local_Task_UpdateTask: "pubId_Local_Task_UpdateTask",
  pubId_Local_Task_AddTask: "pubId_Local_Task_AddTask",
  pubId_Local_Task_UploadAttachment_Success:
    "pubId_Local_Task_UploadAttachment_Success",
  pubId_Local_Task_MarkRead_Success: "pubId_Local_Task_MarkRead_Success",
  pubId_Local_Task_AddSubtask: "pubId_Local_Task_AddSubtask",
  pubId_Local_Task_UpdateSubtask: "pubId_Local_Task_UpdateSubtask",
};

export const talkPubIds = {
  pubId_Talk_NewMessage: "pubId_Talk_NewMessage",
  pubId_Talk_MarkRead: "pubId_Talk_MarkRead",

  pubId_Local_Talk_UploadAttachment_Success:
    "pubId_Local_Talk_UploadAttachment_Success",
  pubId_Local_Talk_InputMessage_Return: "pubId_Local_Talk_InputMessage_Return",
};

export const gptPubIds = {
  pubId_Local_Addin_UserLog: "pubId_Local_Addin_UserLog",
  pubId_Local_Addin_SystemLog: "pubId_Local_Addin_SystemLog",
  pubId_Local_Addin_PrintElement: "pubId_Local_Addin_PrintElement",
  pubId_Local_Gpt_ProcessingText: "pubId_Local_Gpt_ProcessingText",
  pubId_Local_Gpt_Processing_Success: "pubId_Local_Gpt_Processing_Success",
  pubId_Local_Gpt_Processing_Fail: "pubId_Local_Gpt_Processing_Fail",
  pubId_Local_PPT_init_error: "pubId_Local_ppt_init_error",
  pubId_Local_PPT_image_generate_error: "pubId_Local_PPT_image_generate_error",
}

export const gallaryIds = {
  pubId_Local_Image_Generated: "pubId_Local_Image_Generated",
}

export const aisaPubIds = {
  pubId_Local_Aisa_AskGpt_Success: "pubId_Local_Aisa_AskGpt_Success",
  pubId_Local_Aisa_AskGpt_Generating: "pubId_Local_Aisa_AskGpt_Generating",
  pubId_Action_Menu_PPT_From_File_Upload: "pubId_Action_Menu_PPT_From_File_Upload",
  pubId_Action_Menu_PPT_From_File_Finish: "pubId_Action_Menu_PPT_From_File_Finish"
}

export const actionMenuPubIds = {
  pubId_Action_Menu_Whole_Template_PPT: "pubId_Action_Menu_Whole_Template_PPT",
  pubId_Action_Menu_Whole_PPT: "pubId_Action_Menu_Whole_PPT",
  pubId_Action_Menu_One_Page_PPT: "pubId_Action_Menu_One_Page_PPT",
  pubId_Action_Menu_Outline_PPT: "pubId_Action_Menu_Outline_PPT",
  pubId_Action_Menu_PPT_From_File: "pubId_Action_Menu_PPT_From_File",
  pubId_Action_Menu_PPT_From_File_header_action: "pubId_Action_Menu_PPT_From_File_header_action",
  pubId_Action_Menu_clear_action: "pubId_Action_Menu_clear_action",
  pubId_Action_Menu_Click_Change_OnePage_Template: "pubId_Action_Menu_Click_Change_OnePage_Template",
  pubId_Action_Menu_Change_OnePage_Template: "pubId_Action_Menu_Change_OnePage_Template",
}

export const actionUniform = {
  pubId_Action_Uniform_Font: "pubId_Action_Uniform_Font",
  pubId_Action_Uniform_Color: "pubId_Action_Uniform_Color"
}